// src/App.jsx
import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";

import LoginPage from "./components/LoginPage";
import MainPage from "./components/MainPage";
import PasswordChangePage from "./components/PasswordChangePage";

// ▼ 追加コンポーネント: ページ遷移時にスクロールをトップに戻すなど、状態リセットのきっかけを作る
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  // 初期値をlocalStorageから取得
  const [userId, setUserId] = useState(
    localStorage.getItem("userId") ? Number(localStorage.getItem("userId")) : null
  );
  const [userName, setUserName] = useState(localStorage.getItem("userName") || "ゲスト");
  const [isAdmin, setIsAdmin] = useState(localStorage.getItem("isAdmin") === "true");

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        
        {/* ▼▼▼ 修正箇所: ここをシンプルにしました ▼▼▼ */}
        {/* 条件分岐を削除し、ルート(/)には必ず LoginPage を置きます。 */}
        {/* ※もしログイン済みなら、LoginPage内のuseEffectが勝手に /main へ飛ばしてくれるので問題ありません */}
        <Route
          path="/"
          element={
            <LoginPage
              onLogin={(id, name, admin) => {
                setUserId(id);
                setUserName(name);
                setIsAdmin(admin);
                localStorage.setItem("userId", String(id));
                localStorage.setItem("userName", name);
                localStorage.setItem("isAdmin", admin ? "true" : "false");
              }}
            />
          }
        />
        {/* ▲▲▲ 修正ここまで ▲▲▲ */}

        {/* ログイン後のメインページ */}
        <Route
          path="main"
          element={
            userId ? (
              <MainPage
                userId={userId}
                setUserId={setUserId}
                userName={userName}
                setUserName={setUserName}
                isAdmin={isAdmin}
                setIsAdmin={setIsAdmin}
              />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* パスワード変更 */}
        <Route 
          path="password-change" 
          element={
            userId ? <PasswordChangePage /> : <Navigate to="/" replace />
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;